import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MobileSlideOutModal from 'components/consumer/MobileSlideOutModal';
import MobileNavbarExpandableCategory from 'components/nav/MobileNavbarModal/components/MobileNavbarExpandableCategory';
import MobileNavbarSection from 'components/nav/MobileNavbarModal/components/MobileNavbarSection';
import MobileNavbarLink from 'components/nav/MobileNavbarModal/components/MobileNavbarLink';
import useMobileNavItems from 'components/nav/shared/data/useMobileNavItems';
import MobileNavbarFooter from 'components/nav/MobileNavbarModal/components/MobileNavbarFooter';
import isEventWithinLink from 'commons/isEventWithinLink';
const MobileNavbarModalUI = t0 => {
  const $ = _c(21);
  const {
    header,
    isOpen,
    onClose
  } = t0;
  const mobileNavItems = useMobileNavItems();
  const [openCategoryId, setOpenCategoryId] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpenCategoryId(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isOpen) {
    t2 = [isOpen];
    $[1] = isOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onClose) {
    t3 = event => {
      if (isEventWithinLink(event)) {
        onClose();
      }
    };
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== header) {
    t4 = !!header && <div className="mt-0 mx-5 mb-5">{header}</div>;
    $[5] = header;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== mobileNavItems || $[8] !== openCategoryId) {
    let t6;
    if ($[10] !== openCategoryId) {
      t6 = t7 => {
        const {
          id,
          links
        } = t7;
        return <MobileNavbarSection key={id}>{links.map(t8 => {
            const {
              id: itemId,
              color,
              label,
              subLabel,
              images,
              backgroundImage,
              links: categoryLinks,
              to
            } = t8;
            return categoryLinks ? <MobileNavbarExpandableCategory categoryId={itemId} categoryLabel={label} color={color} key={itemId} items={categoryLinks} openCategoryId={openCategoryId} setOpenCategoryId={setOpenCategoryId} /> : <MobileNavbarLink key={itemId} id={itemId} to={to} subLabel={subLabel} images={images} backgroundImage={backgroundImage}>{label}</MobileNavbarLink>;
          })}</MobileNavbarSection>;
      };
      $[10] = openCategoryId;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = mobileNavItems.map(t6);
    $[7] = mobileNavItems;
    $[8] = openCategoryId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MobileNavbarSection><MobileNavbarFooter /></MobileNavbarSection>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t7 = <div className="mb-5 pt-5 pb-5 [&_.ais-SearchBox-reset]:flex-col [&_.ais-SearchBox-reset]:items-center [&_.ais-SearchBox-reset]:justify-center [&_.ais-SearchBox-reset]:w-10" onClick={t3}>{t4}{t5}{t6}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isOpen || $[18] !== onClose || $[19] !== t7) {
    t8 = <MobileSlideOutModal isOpen={isOpen} onClose={onClose} noPadding={true}>{t7}</MobileSlideOutModal>;
    $[17] = isOpen;
    $[18] = onClose;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
MobileNavbarModalUI.propTypes = {
  header: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
export default MobileNavbarModalUI;